export default {
  requiredField: 'Indicates required fields',
  edit: 'Edit details',
  browse: 'Browse',
};
